export default "__VITE_ASSET__DcIz7Fh7__"